export default {
  contactHeroTitle: "Contactez-nous",
  contactHeroSubtitle: "Nous sommes là pour vous aider à naviguer dans le monde complexe du développement pharmaceutique. Que vous ayez besoin de fabrication d'API, de développement de formulations ou de soutien réglementaire, notre équipe est prête à vous aider.",
  contactGetInTouchTitle: "Entrer en contact",
  contactOurAddress: "Notre adresse",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, Inde",
  contactOtherAddresses: "Autres adresses",
  contactAddressBangalore: "Phoenix Mall of Asia – Tour 2,<br />Niveau 6, Unité 602, Yelahanka Hobli,<br />Byatarayanapura, Bangalore – 560092,<br />Karnataka, Inde",
  contactAddressMumbai: "409, Complexe Bezzola,<br />Sion Trombay Road,<br />Chembur, Mumbai - 400 071<br />Maharashtra, Inde.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />Suisse",
  contactEmail: "E-mail",
  contactFormTitle: "Envoyez-nous un message",
  contactFormNameLabel: "Nom complet *",
  contactFormNamePlaceholder: "Entrez votre nom complet",
  contactFormEmailLabel: "Adresse e-mail *",
  contactFormEmailPlaceholder: "Entrez votre adresse e-mail",
  contactFormPhoneLabel: "Numéro de téléphone",
  contactFormPhonePlaceholder: "Entrez votre numéro de téléphone",
  contactFormCompanyLabel: "Entreprise",
  contactFormCompanyPlaceholder: "Entrez le nom de votre entreprise",
  contactFormMessageLabel: "Message *",
  contactFormMessagePlaceholder: "Parlez-nous de votre projet ou de votre demande...",
  contactFormCharacters: "caractères",
  contactFormSubmitButton: "Entrer en contact",
  contactFormSubmitting: "Envoi...",
  contactFormRecaptchaRequired: "Veuillez compléter le reCAPTCHA",
  contactFormSuccess: "Merci ! Votre message a été envoyé avec succès. Nous vous répondrons dans les 24 heures.",
  contactFormError: "Désolé, une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer ou nous contacter directement.",
};

